import Component from './serial_code_table.vue'
export default Component
